import { Minus, TrendingDown, TrendingUp } from "lucide-react";
import { T } from "@/lib/i18n";
import useStockData from "@/hooks/use-stock-data";

const MARKET_SYMBOLS = ["^NSEI", "^BSESN", "^NSEBANK"];

function formatValue(value) {
  return value == null
    ? "—"
    : value.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export default function MarketWidget() {
  const { items = [] } = useStockData();
  const markets = MARKET_SYMBOLS
    .map(symbol => items.find(item => item.symbol === symbol))
    .filter(Boolean);

  return (
    <section className="bg-white border border-[#E2E8F0]" data-testid="market-widget">
      <div className="px-4 py-3 flex items-center justify-between border-b border-[#E2E8F0] bg-slate-50">
        <h3 className="cat-tag text-brand-blue">{T.stockMarket}</h3>
        <span className="text-[0.6rem] tracking-wider text-[#64748B]">INDICES</span>
      </div>
      <div className="divide-y divide-[#E2E8F0] px-4">
        {markets.length ? markets.map(item => {
          const change = item.change_pct;
          const isUp = change > 0;
          const isDown = change < 0;
          const Icon = isUp ? TrendingUp : isDown ? TrendingDown : Minus;
          const changeColor = isUp ? "text-emerald-600" : isDown ? "text-rose-600" : "text-slate-500";

          return (
            <div key={item.symbol} className="py-3 flex items-center justify-between gap-3">
              <div>
                <div className="text-sm font-semibold text-[#0F172A]">{item.label}</div>
                <div className="text-xs text-[#64748B]">{formatValue(item.price)} pts</div>
              </div>
              <div className={`flex items-center gap-1 text-xs font-semibold ${changeColor}`}>
                <Icon className="w-3.5 h-3.5" />
                {change == null ? "—" : `${change > 0 ? "+" : ""}${change}%`}
              </div>
            </div>
          );
        }) : (
          <div className="py-4 text-sm text-[#64748B]">Market data is temporarily unavailable.</div>
        )}
      </div>
      <div className="px-4 py-2 text-[0.65rem] text-[#64748B] bg-slate-50 border-t border-[#E2E8F0]">
        Updates every 5 minutes
      </div>
    </section>
  );
}
